<template>
  <div class="footer">
    <div class="foot-con main-center flex justify-between items-center">
      <div class="copy">
        <p>Copyright&copy;2016-2024 山东教育社 All Rights Reserved.&nbsp;<a target="_blank" href="http://beian.miit.gov.cn">鲁ICP备16007069号-1</a></p>
        <p>本站所有未注明出处的文字、图片等资料版权均为本站所有，未经许可严禁转载!
          <!-- <a target="_blank" class="footer-author" href="http://biaofan.com.cn">技术支持：Biaofun标梵互动</a> -->
        </p>
      </div>
      <div class="pic">
        <img src="@/assets/images/footer.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>
/* 底部部分 */
.footer{width: 100%;}
.footer{ background: #e4393c;padding:30px 0 20px 0;overflow:hidden;}
.footer .change-btn{ position: fixed;right: -6px;top: 240px;width: auto;cursor: pointer; }
.footer .copy p{ line-height:20px; }
.footer .copy p,.footer .copy p a{font-size:14px;font-family:"Microsoft YaHei";font-weight:400;color:rgb(228,233,237);line-height: 24px;}
.footer .copy p .footer-author{color: transparent;}
</style>